import { render } from "./CineAndWebSkeleton.vue?vue&type=template&id=7a4cb2f6&scoped=true"
const script = {}

import "./CineAndWebSkeleton.vue?vue&type=style&index=0&id=7a4cb2f6&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4cb2f6"]])

export default __exports__